import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const CssTextField = withStyles({
  root: {
    margin: '1rem',
    '& label.Mui-focused': {
      color: '#4d74ba',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#4d74ba',
    },
  },
})(TextField);

const CssTextFieldAppColor = withStyles({
  root: {
    margin: '1rem',
    flexGrow: '0 !important',
    '& label.Mui-focused': {
      color: '#FCA40C',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#FCA40C',
    },
  },
})(TextField);

const input = ({
  value,
  style,
  label,
  setValue,
  flexGrow,
  flexShrink,
  width,
  inputType,
  fullWidth = false,
  applyAppColor,
  useAsTextarea,
  error = false,
  errorMessage = '',
  autoFocus = false,
  disabled = false,
}) =>
  applyAppColor ? (
    <CssTextFieldAppColor
      style={{
        ...style,
        flexGrow: flexGrow ? flexGrow : 1,
        flexShrink: flexShrink ? flexShrink : 1,
        width: width ? width : 'auto',
      }}
      label={label}
      value={value}
      onChange={setValue}
      type={inputType ? inputType : 'text'}
      multiline={useAsTextarea}
      autoFocus={autoFocus}
      error={error}
      fullWidth={fullWidth}
      helperText={errorMessage}
      disabled={disabled}
    />
  ) : (
    <CssTextField
      style={{
        ...style,
        flexGrow: flexGrow ? flexGrow : 1,
        flexShrink: flexShrink ? flexShrink : 1,
        width: width ? width : 'auto',
      }}
      label={label}
      value={value}
      onChange={setValue}
      type={inputType ? inputType : 'text'}
      multiline={useAsTextarea}
      autoFocus={autoFocus}
      error={error}
      fullWidth={fullWidth}
      helperText={errorMessage}
      disabled={disabled}
    />
  );

export default input;
